import { User } from '@src/main/modules/user/domain/user.interface';
import { UserRepository } from '@src/main/modules/user/domain/user.repository';

export const findAllUsers = async (repository: UserRepository): Promise<User[]> =>
  await repository.findAll();
